import * as React from 'react';
import { ToolbarConfig, MenuConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import { TOOLBAR_TEXT } from '@editor/src/img/pageIndex';
import { wrapIdForBig } from '@framework/workbench/util/wrap-id-util';
import { TDWActionType, TDWModuleType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

export const config = {
    id: ActionType.INSERT_TEXT,
    tipMsg: i18n.t('插入文本框'),
    title: i18n.t('文本框'),
    icon: TOOLBAR_TEXT,
    twdConfig: {
        handleFunction: (value, clickFrom) => {
            const module = clickFrom ? TDWModuleType.PC_TOOLBAR : TDWModuleType.PC_TOOLBAR_INSERT;
            return {
                module,
                action: TDWActionType.TEXT_BOX,
            };
        },
    },
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        tooltip: config.tipMsg,
        icon: <img src={config.icon} alt={''}/>,
        style: {
            width: 'auto',
        },
    },
    {
        name: wrapIdForBig(config.id),
        tooltip: config.tipMsg,
        text: i18n.t('文本框'),
        icon: <img src={config.icon} alt={''}/>,
        style: {
        },
    },
];

export const INSERT_TEXT_MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.title,
        icon: <img src={config.icon} alt={''}/>,
        tooltip: config.tipMsg,
    },
];
